import { LOADING } from "../../../constants/constant";
import {
  GET_DASHBOARD_ANALYTICS,
  GET_DASHBOARD_ANALYTICS_SUCCESS,
  GET_DASHBOARD_ANALYTICS_FAILED,
  GET_DASHBOARD_ANALYTICS_RESET,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: false,
};

export default function filterDashboardSummary(state = initialState, action) {
  switch (action.type) {
    case GET_DASHBOARD_ANALYTICS:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case GET_DASHBOARD_ANALYTICS_SUCCESS:
      let filteredData = Object.assign({}, state);
      filteredData.status = action.data.message;
      filteredData.isLoading = false;
      filteredData.statusCode = action.data.status_code;
      filteredData.cardSummary = action.data.data.finalMap
        ? action.data.data.finalMap
        : [];
      filteredData.tableData = action.data.data.summaryList
        ? action.data.data.summaryList
        : [];
      return filteredData;

    case GET_DASHBOARD_ANALYTICS_FAILED:
      return Object.assign({}, state, action.error);

    case GET_DASHBOARD_ANALYTICS_RESET:
      return initialState;

    default:
      return state;
  }
}
